// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cover-letter {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  background: linear-gradient(180deg, #0a0f1c 0%, #111827 100%);
  color: #ffffff;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  padding-bottom: 4rem;
}

/* ===== Header ===== */
/* Header layout */
.cover-letter header {
  display: flex;
  flex-direction: column;
  align-items: center; /* centers the title + contact info */
  text-align: center;
  position: relative; /* allows absolute positioning for the button */
  width: 90%;
  max-width: 900px;
  margin: 0 auto;
}

/* Print button positioning */
.cover-letter .prt-button {
  position: absolute;
  left: 0;       /* pins to left edge of header */
  top: 0;        /* aligns with top of header */
  transform: translateY(0); /* optional fine-tune vertical position */
}

.cover-letter h1 {
  font-size: 2.2rem;
  font-weight: 700;
  color: #00aeef;
  letter-spacing: 0.5px;
  margin-bottom: 0.5rem;
}

.cover-letter .contact {
  font-size: 1rem;
  color: #cfd8dc;
  margin-bottom: 0.5rem;
}

.cover-letter .contact a {
  color: #00aeef;
  text-decoration: none;
  transition: color 0.3s ease;
}

.cover-letter .contact a:hover {
  color: #0078d4;
  text-decoration: underline;
}



/* ===== Letter Body ===== */
.letter-body {
  width: 90%;
  max-width: 900px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 0 25px rgba(0, 174, 239, 0.25);
  backdrop-filter: blur(6px);
  animation: slideUp 1.2s ease-in-out;
  line-height: 1.6;
  color: #e0e0e0;
}

.letter-body p {
  margin-bottom: 1rem;
  font-size: 1rem;
}

.letter-body .closing {
  margin-top: 2rem;
  font-weight: 600;
  color: #00aeef;
}

/* ===== Print Button ===== */
.cover-letter button,
.cover-letter .prt-button {
  background: #00aeef;
  color: #fff;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.3s ease;
}

.cover-letter button:hover,
.cover-letter .prt-button:hover {
  background: #0078d4;
  transform: translateY(-3px);
}

/* ===== Animations ===== */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== Footer (optional) ===== */
.cover-letter footer {
  text-align: center;
  margin-top: 3rem;
  font-size: 0.9rem;
  color: #b0bec5;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1.5rem;
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .cover-letter h1 {
    font-size: 1.8rem;
  }

  .letter-body {
    padding: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CoverLetter.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,6DAA6D;EAC7D,cAAc;EACd,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,qCAAqC;EAC1D,kBAAkB;EAClB,kBAAkB,EAAE,+CAA+C;EACnE,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,OAAO,QAAQ,gCAAgC;EAC/C,MAAM,SAAS,8BAA8B;EAC7C,wBAAwB,EAAE,yCAAyC;AACrE;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;;;AAIA,4BAA4B;AAC5B;EACE,UAAU;EACV,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,0BAA0B;EAC1B,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;;EAEE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;;EAEE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".cover-letter {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 100vh;\n  background: linear-gradient(180deg, #0a0f1c 0%, #111827 100%);\n  color: #ffffff;\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  padding-bottom: 4rem;\n}\n\n/* ===== Header ===== */\n/* Header layout */\n.cover-letter header {\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* centers the title + contact info */\n  text-align: center;\n  position: relative; /* allows absolute positioning for the button */\n  width: 90%;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n/* Print button positioning */\n.cover-letter .prt-button {\n  position: absolute;\n  left: 0;       /* pins to left edge of header */\n  top: 0;        /* aligns with top of header */\n  transform: translateY(0); /* optional fine-tune vertical position */\n}\n\n.cover-letter h1 {\n  font-size: 2.2rem;\n  font-weight: 700;\n  color: #00aeef;\n  letter-spacing: 0.5px;\n  margin-bottom: 0.5rem;\n}\n\n.cover-letter .contact {\n  font-size: 1rem;\n  color: #cfd8dc;\n  margin-bottom: 0.5rem;\n}\n\n.cover-letter .contact a {\n  color: #00aeef;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.cover-letter .contact a:hover {\n  color: #0078d4;\n  text-decoration: underline;\n}\n\n\n\n/* ===== Letter Body ===== */\n.letter-body {\n  width: 90%;\n  max-width: 900px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 2.5rem;\n  box-shadow: 0 0 25px rgba(0, 174, 239, 0.25);\n  backdrop-filter: blur(6px);\n  animation: slideUp 1.2s ease-in-out;\n  line-height: 1.6;\n  color: #e0e0e0;\n}\n\n.letter-body p {\n  margin-bottom: 1rem;\n  font-size: 1rem;\n}\n\n.letter-body .closing {\n  margin-top: 2rem;\n  font-weight: 600;\n  color: #00aeef;\n}\n\n/* ===== Print Button ===== */\n.cover-letter button,\n.cover-letter .prt-button {\n  background: #00aeef;\n  color: #fff;\n  border: none;\n  padding: 0.6rem 1.2rem;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.3s ease, transform 0.3s ease;\n}\n\n.cover-letter button:hover,\n.cover-letter .prt-button:hover {\n  background: #0078d4;\n  transform: translateY(-3px);\n}\n\n/* ===== Animations ===== */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ===== Footer (optional) ===== */\n.cover-letter footer {\n  text-align: center;\n  margin-top: 3rem;\n  font-size: 0.9rem;\n  color: #b0bec5;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  padding-top: 1.5rem;\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 768px) {\n  .cover-letter h1 {\n    font-size: 1.8rem;\n  }\n\n  .letter-body {\n    padding: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
